module.exports = __webpack_public_path__ + "img/vn.1579680f.png";